import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { MODAL_CLOSE } from 'redux/slices/modals';
import { Icon } from 'ui/atoms';
import { ChangeAccountPassword } from 'ui/components';
import { Container } from 'ui/gridSystem';
import MainFont from 'ui/typography/mainFont';

import Modal, { stopEvent } from '../Modal';
import {
  IconClose,
  ModalGlobalContainer,
  ModalTitle,
  ModalWrapper
} from '../Modal.style';
import { ModalContainer } from './style';

const modalId = 'ChangeAccountPasswordModal';

const ChangeAccountPasswordModal = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer onMouseDown={stopEvent} onClick={stopEvent}>
            <ModalTitle>
              <MainFont
                configuration={{ fontSize: 24, fontWeight: 600 }}
                type="3"
              >
                {t('change_password')}
              </MainFont>
              <IconClose>
                <Icon type="icon-close-modal" size={20} onClick={onClose} />
              </IconClose>
            </ModalTitle>
            <ModalContainer>
              <ChangeAccountPassword closeModal={onClose} />
            </ModalContainer>
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

ChangeAccountPasswordModal.id = modalId;

ChangeAccountPasswordModal.propTypes = {
  onClose: PropTypes.func
};

export default connect(
  state => ({
    payload: state.modals?.payload
  }),
  dispatch => ({ onClose: () => dispatch(MODAL_CLOSE()) })
)(ChangeAccountPasswordModal);
